const routes = {
  importInvoice: 'invoices/import',
  createInvoice: 'invoices',
  getInvoices: 'invoices',
  getInvoiceById: 'invoices/',
  updateInvoice: 'invoices/',
  deleteInvoice: 'invoices/',
  validateInvoice: 'invoices/validate',
  submitInvoice: 'invoices/submit',
};

export default routes